import React, { forwardRef } from 'react';
import { SketchField } from '../Sketch';
import './index.scss';

const Step = forwardRef((props, ref) => {
  const { step, currentStep, brushColor, brushRadius, brushShape, eraser } = props;

  return <SketchField ref={ref} className={`canvas ${step === currentStep ? 'canvas--visible' : 'canvas'}`} width={700} height={415} tool={brushShape} lineColor={eraser ? '#ffffff' : brushColor} lineWidth={brushRadius} backgroundColor='#ffffff' />;
});

export default Step;
